import React, { Component } from 'react';
import {} from '../App.css';


class AboutHome extends Component {
    constructor(props) {
        super(props);
        document.title = "g-C3N4 About This Site";
        this.state = {
            loaded: false
        };
        
        this.state = {
            loaded: true
        };
    
    }
    openMailto() {
        window.location.href='mailto:info@g-c3n4.com?subject=Web Site Enquiry&body=Hi g-C3N4 team,';
    }
    render() {
        if (this.state.loaded) {
            return (
                <div className="container">
                    <p className="title">About </p>
                    <p className="subtitle">Who we are, what we do and how we do it. </p>
        
                    <p className="paragraph-heading">Who we are</p>
                    <p>We are like minded individuals whose intent is to produce innovative and useful open source g-C3N4 products. 
                    </p>    
                    <p className="paragraph-heading">Who we are</p>
                    <p> We do all our experimentation in our spare time and have day jobs to pay the bills. 
                        Our experinemtation is put into the public domain so that everyone can benefit. 
                        We also strive to create technologies that are reliable, sustainable and can be created using inexpensive materials without a laboritory. 
                    </p>
                    <p className="paragraph-heading">How we do it</p>
                    <p>You'll find our articles and videos in the Open Source section so you can find out the kind of things that we're up to. Hopefully it will inspire you to not only reporoduce, but improve on.  
                    </p>   
                    <p className="paragraph-heading">Get in Touch </p>
                    <p>We crave feedback and support so please get in touch any time at:
                    </p>   
                    
                    <p className="Pointer" onClick={this.openMailto}>info [at] g-C3N4.com</p>
                    <br/><br/>
                    <p>Thanks for using our site</p>
                    <h3>The g-C3H4 Team</h3>
                </div>
            );
        } else {
            return (
                <div>
                    Loading...
                </div>
            )
        }
    }
}

export default AboutHome;


// WEBPACK FOOTER //
// ./src/Home/AboutHome.js